import { render, staticRenderFns } from "./CustomDetailsInput.vue?vue&type=template&id=04d00830&scoped=true"
import script from "./CustomDetailsInput.vue?vue&type=script&lang=js"
export * from "./CustomDetailsInput.vue?vue&type=script&lang=js"
import style0 from "./CustomDetailsInput.vue?vue&type=style&index=0&id=04d00830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d00830",
  null
  
)

export default component.exports